import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  z-index: 9999;
`;

export const Dialog = styled.div`
  background-color: white;
  width: 80%;
  max-width: 600px;
  min-height: 200px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 250px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: center;
  display: flex;
  padding: 15px;
`;

export const Text = styled.p`
  color: black;
`;

export const VehicleLink = styled.p`
  text-decoration: underline;
  color: red;
  cursor: pointer;
  margin: 5px 15px;
  
  &:hover {
    text-decoration: none;
  }
`;
